import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { UserList } from './Backend/Users/UserList';
import { UserCreate } from './Backend/Users/UserCreate';
import { DoctorList } from './Backend/Contacts/DoctorList';
import DoctorCreate from './Backend/Contacts/DoctorCreate';
import { DoctorDetails } from './Backend/Contacts/DoctorDetails';
import { ContactList } from './Backend/Contacts/ContactList';
import CustomerProfileCreate from './Backend/Contacts/CustomerProfileCreate';
import { SpecializationList } from './Backend/Masters/Specialization/SpecializationList';
import { QualificationList } from './Backend/Masters/Qualification/QualificationList';
import { SymptomsList } from './Backend/Masters/Symptoms/symptomsList';
import { BrandList } from './Backend/Masters/Brand/BrandList';
import { DoctorServiceList } from './Backend/Masters/DoctorService/DoctorServiceList';
import { VendorTypeList } from './Backend/Masters/VendorType/VendorTypeList';
import { Specialization } from './Backend/Masters/Specialization/SpecializationCreate';
import { Qualification } from './Backend/Masters/Qualification/Qualification';
import { Symptoms } from './Backend/Masters/Symptoms/SymptomsCreate';
import { Brand } from './Backend/Masters/Brand/Brand';
import { DoctorService } from './Backend/Masters/DoctorService/DoctorService';
import { VendorType } from './Backend/Masters/VendorType/VendorType';
import { ChangePassword } from './Pages/ChangePassword/ChangePassword';
import VendorProfile from './Backend/Contacts/VendorProfile';
import { BookingList } from './Backend/Transactions/Booking/BookingList';
import { WalletsList } from './Backend/Transactions/Wallet/WalletList';
import { WithdrawalList } from './Backend/Transactions/Wallet/WithdrawelList';
import { VendorProfileSetUp } from './Pages/VendorProfileSetUp/VendorProfileSetUp';
import { MedicalCategoryList } from './Backend/Masters/MedicalCategory/MedicalCategoryList';
import { MedicalCategory } from './Backend/Masters/MedicalCategory/MedicalCategory';
import { VendorTabList } from './Backend/Contacts/VendorTabList';
import DateScheduleCreate from './Backend/Contacts/DateScheduleCreate';
import DateSchedule from './Backend/Contacts/DateSchedule';
import { Booking } from './Backend/Transactions/Booking/Booking';
import { DoctorSearchBooking } from './Backend/Transactions/Booking/DoctorSearchBooking';










interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  // if (!token) {
  //   return token ? <Outlet /> : <Navigate to="/login" />;
  // }

  return (
    <Routes>
      {/* <Route path="/" element={<Layout />}/> */}

      <Route path='/user/list' element={<UserList />} />
      <Route path='/user/add' element={<UserCreate />} />
      <Route path='/user/edit/:id' element={<UserCreate />} />

      <Route path='/contact/list/:tab?' element={<ContactList />} />
      <Route path='/doctor/profile/add/:userId' element={<DoctorCreate />} />
      <Route path='/doctor/profile/add/:userId/schedule' element={<DateScheduleCreate />} />

      <Route path='/doctor/profile/edit/:id' element={<DoctorCreate />} />

      <Route path='/doctor/profile/edit/:profileId/schedule' element={<DateSchedule />} />

      <Route path='/doctor/details' element={<DoctorDetails />} />

      <Route path='/contact/customer/list' element={<ContactList />} />
      <Route path='/customer/profile/add/:userId' element={<CustomerProfileCreate />} />
      <Route path='/customer/profile/edit/:id' element={<CustomerProfileCreate />} />

      <Route path='/specialization/list' element={<SpecializationList />} />
       <Route path='/specialization/create' element={<Specialization />} />
      <Route path='/specialization/edit/:id' element={<Specialization />} /> 

      <Route path='/qualification/list' element={<QualificationList />} />
      <Route path='/qualification/create' element={<Qualification />} />
      <Route path='/qualification/edit/:id' element={<Qualification />} />

      <Route path='/symptoms/list' element={<SymptomsList />} />
      <Route path='/symptoms/create' element={<Symptoms />} />
      <Route path='/symptoms/edit/:id' element={<Symptoms />} />

      <Route path='/brand/list' element={<BrandList />} />
      <Route path='/brand/create' element={<Brand />} />
      <Route path='/brand/edit/:id' element={<Brand />} />

      <Route path='/doctor-service/list' element={<DoctorServiceList />} />
      <Route path='/doctor-service/create' element={<DoctorService />} />
      <Route path='/doctor-service/edit/:id' element={<DoctorService />} />


      {/* <Route path='/vendor-service/list' element={<VendorTypeList />} />
      <Route path='/vendor-service/create' element={<Vendor />} />
      <Route path='/vendor-service/edit/:id' element={<VendorType />} /> */}

      <Route path='/vendor-type/list' element={<VendorTypeList />} />
      <Route path='/vendor-type/create' element={<VendorType />} />
      <Route path='/vendor-type/edit/:id' element={<VendorType />} />


      <Route path='/vendor/list' element={<VendorTabList />} />
      <Route path='/vendor/profile/add/:userId' element={<VendorProfile />} />
      <Route path='/vendor/profile/edit/:id' element={<VendorProfile />} />
      <Route path='/changepassword' element={<ChangePassword />} />

      <Route path='/booking/list' element={<BookingList />} />
      <Route path='/wallet/list' element={<WalletsList />} />
      <Route path='/withdrawal/list' element={<WithdrawalList />} />

      <Route path='/medical-category/list' element={<MedicalCategoryList />} />
      <Route path='/medical-category/create' element={<MedicalCategory />} />
      <Route path='/medical-category/edit/:id' element={<MedicalCategory />} />
      <Route path='/booking/list/book/add/id/:id/profile/:doctorProfileId' element={<Booking />} />
      <Route path='/booking/list/book' element={<DoctorSearchBooking />} />

    </Routes>
  );
};

export default PrivateRoute;
